
import AxiosApiClient from './AxiosApiClient';
import AuthUtility from '../frontend/auth/AuthUtility';

import $ from 'jquery'; // Import jQuery

const error_style = 'font-source-sans font-small font-weight-500 txt-000 bg-light-red p-5';

const initialPasswordInput = {
    email: '',
    password: '',
    new_password: '',
    app: process.env.REACT_APP_NAME,
    errorList: [],
    errorStyle: [],
};

// helper for API backend selection
const getAuthApi = () => {
    return localStorage.getItem('auth_api') && localStorage.getItem('auth_api') !== ''
        ? localStorage.getItem('auth_api')
        : 'phpLaravel';
};

export const PasswordService = (event, { passwordInput, setPasswordInput, setViewMode, setIsLoading, navHistory, swal }) => {
    if (event) event.preventDefault();

    setIsLoading(true);

    // Create FormData instance
    const formData = new FormData();

    appendIfNotNull(formData, 'email', passwordInput.email);
    appendIfNotNull(formData, 'password', passwordInput.password);
    appendIfNotNull(formData, 'new_password', passwordInput.new_password);
    appendIfNotNull(formData, 'app', passwordInput.app);
    formData.append('mode', 'edit');

    const fetchApiDataSavePassword = async () => {
        try {
            const { getBearerToken, makeRequestWithHeaders } = AxiosApiClient({
                apiBackend: getAuthApi(),
                token: localStorage.getItem('auth_token'),
            });

            await getBearerToken();
            const response = await makeRequestWithHeaders('post', '/api/save_password', formData, {
                params: {
                    'Authorization': `Bearer ${localStorage.getItem('auth_token')}`,
                },
            });

            setApiDataSavePassword(response, "PasswordService", { passwordInput, setPasswordInput, setViewMode, setIsLoading, navHistory, swal });
        } catch (error) {
            handleApiErrorSavePassword(error, "PasswordService", { setViewMode, setIsLoading, navHistory, swal });
        }
    };

    fetchApiDataSavePassword();
};

function setApiDataSavePassword(response, theFunction, { passwordInput, setPasswordInput, setViewMode, setIsLoading, navHistory, swal }) {
    if (response && response.data) {
        if (response.data.status === 200) {//HTTP_OK
            console.log(theFunction + ': ', response.data.message);

            AuthUtility.setPasswordData(response.data.new_password);

            setPasswordInput(initialPasswordInput);

            setViewMode('view_account');
            swal("Info", response.data.message, "info");
        } else if (response.data.status === 401) {//HTTP_UNAUTHORIZED
            console.log(theFunction + ' error: ', response.data.message + ' back-end api call error');

            //user not authenticated on server so remove from local storage
            AuthUtility.clearAuthData();

            setIsLoading(false);
            navHistory('/login');
        } else if (response.data.status === 404) {//HTTP_NOT_FOUND
            console.log(theFunction + ' error: ', response.data.message + ' back-end api call error');

            setIsLoading(false);
            swal("Warning", response.data.message, "warning");
        } else if (response.data.status === 422) {//HTTP_UNPROCESSABLE_ENTITY
            console.log(theFunction + ' error: ', response.data.message + ' back-end api call error');

            setIsLoading(false);
            swal("Warning", response.data.message, "warning");
        } else if (response.data.status === 800) {//HTTP_FORM_VALIDATION_FAILED
            console.log(theFunction + ': ', response.data.message + ' HTTP_FORM_VALIDATION_FAILED');

            var errorStyleTemp = JSON.parse(JSON.stringify(response.data.validation_errors));
            Object.keys(errorStyleTemp).map((key) => (
                errorStyleTemp[key] = error_style
            ));
            Object.keys(errorStyleTemp).map((key) => (
                $('#' + key + '_message').addClass('hide') //clear any previous message
            ));

            //validation errors mapped to input fields
            setPasswordInput({ ...passwordInput, errorList: response.data.validation_errors, errorStyle: errorStyleTemp });
        } else {//more errors
        }
    }

    setIsLoading(false);
}

function handleApiErrorSavePassword(error, theFunction, { setIsLoading, navHistory, swal }) {
    console.log(theFunction + ' error: ', error + ' back-end api call error');

    AuthUtility.clearAuthData();
    AuthUtility.clearOrganizationData();

    setIsLoading(false);
    swal("Error", error.toString(), "error");
    navHistory('/login');
}

// Helper function
const appendIfNotNull = (formData, key, value) => {
    if (value !== null && value !== undefined && value !== "null") {
        formData.append(key, value);
    } else {
        formData.append(key, ''); // or skip if your backend interprets missing fields as null
    }
};